import styled from "styled-components";
import media from "../../../../styles/media";

export const ClassContentWrapper = styled.div`
	margin: 23px 0 41px 0;
	background: linear-gradient(
		180deg,
		rgba(254, 254, 254, 0) 89.06%,
		#fefefe 94.65%,
		#fefefe 98.01%
	);
	border: 1px solid #efefef;
	box-sizing: border-box;
	border-radius: 6px;
	width: 100%;

	p {
		line-height: 1.2em;
		margin: 0 0 20px;

		a {
			color: ${(props) => props.theme.color.primary};
			text-decoration: underline;
			transition: 0.3s;
			word-break: break-all;

			&:hover {
				opacity: 0.6;
			}
		}
	}
`;

export const LeiaMaisButtonWrapper = styled.div`
	background: linear-gradient(
		to bottom,
		rgba(255, 255, 255, 0) 0,
		rgba(255, 255, 255, 1) 34%
	);
	min-height: 80px;
	padding: 25px 0 15px;
	text-align: center;
	margin: -20px 0 0;
	position: absolute;
	width: 100%;
	z-index: 10;
	bottom: 0;
	left: 0;

	${media.lessThan("medium")`
		position: relative;
		background: #fff;
	`}

	button {
		background: none;
		font-size: 1.125rem;
		color: ${(props) => props.theme.color.primary};
		cursor: pointer;
		border: none;
		padding: 8px 16px;

		&:focus {
			outline: 2px solid ${(props) => props.theme.color.primary};
			outline-offset: 2px;
		}

		&:hover {
			text-decoration: underline;
		}
	}
`;

export const ContentSection = styled.div`
	background: #fff;
	position: relative;

	&.with-padding {
		padding: 31px 20px;
	}
`;

export const QuizSection = styled.div`
	background: #fff;
	position: relative;
	margin-top: -50px;
	padding: 0 20px 31px 20px;
`;

export const DescriptionWrapper = styled.div`
	width: 100%;
	overflow: visible;
`;
